import React from "react";
import Iframe from 'react-iframe'
import BackButtons from "../common/backbuttons";

class MainMapSection extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section className="wrapper style1 align-center color4 invert">
                <div className="inner">
                    <h2>Live Map</h2>
                    <p>A discapito della mia privacy, una mappa realtime con i luoghi dove sono stato e dove sono ora.<br />I punti segnati sono rilevati e georeferenziati tramite Spot GPS</p>
                    <div className="index align-left">
                        <section>
                            <div className="content">
                                <Iframe styles={{position:"relative"}} display={"block"} width="100%" height="500" 
                                    url="https://spotwalla.com/embed.php?id=1c85a5c56ecec6de20&scale=on&zoom=default&refresh=no&hoursPast=0"/>
                            </div>
                        </section>
                    </div>
                </div>
                <BackButtons backElement="spotlightsElements"/>
            </section>
        )
    }
}

export default MainMapSection